var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayback = function SvgPlayback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 174 178"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 6,
    d: "M170.214 89c0 47.574-37.509 86-83.607 86S3 136.574 3 89 40.509 3 86.607 3s83.607 38.426 83.607 86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "M112.029 76.68c7.836 4.649 7.836 15.991 0 20.64l-33.086 19.631c-8 4.746-18.123-1.019-18.123-10.321V67.37c0-9.302 10.123-15.067 18.122-10.32z"
  })));
};
export default SvgPlayback;